module.exports = __webpack_public_path__ + "static/img/cychgl.1c52c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT006/cychgl.png
// module id = mxkz
// module chunks = 1